module.exports = __webpack_public_path__ + "img/all_icon.da619d95.png";